<div class="modal-container">
  <h1 i18n>Select labels</h1>
  <div class="input-wrapper">
    <app-multi-select [labels]="labels" [multiSelectType]="MultiSelectType.LABEL" [showControlButtons]="false" [formControl]="labelControl">
    </app-multi-select>
  </div>

  <section class="buttons">
    <button class="close-button" (click)="closeModal()" i18n>Cancel</button>
    <button class="submit-button" (click)="saveLabels()" i18n>Save selection</button>
  </section>
</div>
